import React, {Component} from "react";
import { observer } from "mobx-react";
import {fn_setOrderSoldOutProdCode} from "../../../../../function/FnBodyDetail";

@observer
class SoldOutViewItem extends Component {
    constructor(props) {
        super(props);
        this.scrollSet = props.scrollSet.bind(this);
    }

    render() {

        const { rootStore, prod } = this.props;
        const viewStore = rootStore.viewStore;
        return(
                <li className={viewStore.getOrderSoldOutConn===prod.prodCode?"open":""}>
                    <label>
                        <input type="checkbox" checked={prod.soldOutYn==="Y"} readOnly={prod.soldOutYn==="Y"}
                            onChange={ event => {
                                viewStore.setOrderSoldOutProd(prod.prodCode);
                                //목록 스크롤 위치 다시 지정.(마우스휠 이동할 경우 대응)
                                let soldOutArea = document.getElementById("soldOutLayer");
                                this.scrollSet(soldOutArea.scrollTop);
                            }}
                        />
                        <span className="ico"></span>
                        <span className="txt">{prod.prodName}</span>
                    </label>
                    {
                        prod.connProdName?
                            <>
                                <button type="button" className="btn"
                                    onClick={
                                        event => {
                                            fn_setOrderSoldOutProdCode(rootStore, prod.prodCode);
                                            //목록 스크롤 위치 다시 지정.(마우스휠 이동할 경우 대응)
                                            let soldOutArea = document.getElementById("soldOutLayer");
                                            this.scrollSet(soldOutArea.scrollTop);
                                        }
                                    }
                                ><span>연결메뉴</span></button>
                                <span className="detail">
                                   {prod.connProdName}
                                </span>
                            </>
                        :null
                    }

                </li>

        );
    }
}

export default SoldOutViewItem;